export * from "ce/entities/FeatureFlag";
import {
  FEATURE_FLAG as CE_FEATURE_FLAG,
  DEFAULT_FEATURE_FLAG_VALUE as CE_DEFAULT_FEATURE_FLAG_VALUE,
} from "ce/entities/FeatureFlag";

const EE_FEATURE_FLAG = {
  ask_ai: "ask_ai",
  ask_ai_js: "ask_ai_js",
  ask_ai_sql: "ask_ai_sql",
  ab_ai_js_function_completion_enabled: "ab_ai_js_function_completion_enabled",
  TEST_EE_FLAG: "TEST_EE_FLAG",
  license_audit_logs_enabled: "license_audit_logs_enabled",
  license_custom_environments_enabled: "license_custom_environments_enabled",
  license_connection_pool_size_enabled: "license_connection_pool_size_enabled",
  release_knowledge_base_enabled: "release_knowledge_base_enabled",
  license_session_limit_enabled: "license_session_limit_enabled",
  license_session_timeout_enabled: "license_session_timeout_enabled",
  license_pac_enabled: "license_pac_enabled",
  license_message_listener_enabled: "license_message_listener_enabled",
  ab_ai_button_sql_enabled: "ab_ai_button_sql_enabled",
  license_scim_enabled: "license_scim_enabled",
  release_query_module_enabled: "release_query_module_enabled",
  release_ui_module_enabled: "release_ui_module_enabled",
  ab_env_walkthrough_enabled: "ab_env_walkthrough_enabled",
  release_workflows_enabled: "release_workflows_enabled",
  rollout_workflow_scheduler_enabled: "rollout_workflow_scheduler_enabled",
  release_jit_package_pull_enabled: "release_jit_package_pull_enabled",
  release_workflows_hitl_query_enabled: "release_workflows_hitl_query_enabled",
  release_workflows_hitl_crud_enabled: "release_workflows_hitl_crud_enabled",
  release_multi_env_view_mode_enabled: "release_multi_env_view_mode_enabled",
  license_responses_api_enabled: "license_responses_api_enabled",
  release_ui_module_private_entities_enabled:
    "release_ui_module_private_entities_enabled",
  release_ui_module_on_input_change_enabled:
    "release_ui_module_on_input_change_enabled",
  release_ssh_key_manager_enabled: "release_ssh_key_manager_enabled",
  license_ask_ai_config_enabled: "license_ask_ai_config_enabled",
  license_anvil_enabled: "license_anvil_enabled",
} as const;

export const EE_DEFAULT_FEATURE_FLAG_VALUE: EE_FeatureFlags = {
  ask_ai: false,
  ask_ai_js: false,
  ask_ai_sql: false,
  ab_ai_js_function_completion_enabled: false,
  TEST_EE_FLAG: true,
  license_audit_logs_enabled: false,
  license_custom_environments_enabled: false,
  license_connection_pool_size_enabled: false,
  release_knowledge_base_enabled: false,
  license_session_limit_enabled: false,
  license_session_timeout_enabled: false,
  license_pac_enabled: false,
  license_message_listener_enabled: false,
  release_query_module_enabled: false,
  release_ui_module_enabled: false,
  release_workflows_enabled: false,
  ab_ai_button_sql_enabled: false,
  license_scim_enabled: false,
  ab_env_walkthrough_enabled: false,
  rollout_workflow_scheduler_enabled: false,
  release_jit_package_pull_enabled: false,
  release_workflows_hitl_query_enabled: false,
  release_workflows_hitl_crud_enabled: false,
  release_multi_env_view_mode_enabled: false,
  license_responses_api_enabled: false,
  release_ui_module_private_entities_enabled: false,
  release_ui_module_on_input_change_enabled: false,
  release_ssh_key_manager_enabled: false,
  license_ask_ai_config_enabled: false,
  license_anvil_enabled: false,
};

export type EE_FeatureFlag = keyof typeof EE_FEATURE_FLAG;
export type EE_FeatureFlags = Record<EE_FeatureFlag, boolean>;

export const FEATURE_FLAG = {
  ...CE_FEATURE_FLAG,
  ...EE_FEATURE_FLAG,
} as const;

export const DEFAULT_FEATURE_FLAG_VALUE = {
  ...CE_DEFAULT_FEATURE_FLAG_VALUE,
  ...EE_DEFAULT_FEATURE_FLAG_VALUE,
};

export type FeatureFlag = keyof typeof FEATURE_FLAG;
export type FeatureFlags = Record<FeatureFlag, boolean>;
